<template>
  <el-dialog
            title="批量导入"
            :visible="true"
            width="50%"
            :append-to-body=true
           
            :before-close="handleClose">
   <div>
        <div class="title">成功导入{{table.total_success}}条,失败{{table.total_failure}}条</div>
      <el-table
    :data="table.failure_data"
    border
    style="width: 100%;margin: 20px;height:auto">
    <el-table-column
    fixed
      prop="product_sn"
      label="商品编号"
     >
    </el-table-column>
    <el-table-column
      prop="product_name"
      label="商品名称"
      width="180">
    </el-table-column>
    <el-table-column
      prop="address"
      label="是否赠品">
      <template slot-scope="scope"> 
          {{scope.row.isgift==1?'赠品':'非赠品'}}
      </template>
    </el-table-column>
     <el-table-column
      prop="address"
        width="130"
      label="经销商级别">
    </el-table-column>
     <el-table-column
      prop="address"
      width="250"
      label="商品价格">
          <template slot-scope="scope">
                            <!-- {{scope.row}} -->
                          <div v-for='(v,k) in scope.row.directly_dealer_price' :key='k' class='price' >
                               <div>下级{{v.level_name}}:{{v.price}}</div>
                          </div>
                          <div class='price'> 
                              <div>门店{{scope.row.directly_shop_directly_price}}</div>
                          </div>
                        </template>
    </el-table-column>
     <el-table-column
      prop="directly_shop_directly_price"
        width="120"
      label="直营门店价格">
    </el-table-column>
     <el-table-column
      prop="directly_shop_not_directly_price"
        width="120"
      label="非直营门店价格">
     
    </el-table-column>
     <el-table-column
      prop="attribute_name"
      label="商品属性">
    </el-table-column>
     <el-table-column
     width="200"
      prop="error_msg"
      fixed='right'
      label="失败原因">
    </el-table-column>
  </el-table>
  <el-button type="primary" @click='done()'>完成</el-button>
  
   </div>
  </el-dialog>
</template>
<script>
export default {
    name:'importDetail',
    data(){
        return{
          
        }
    },
    methods:{
        done(){

             this.$emit('refresh');
        },
        handleClose(){
             this.$emit('handleClose');

        }
    },
    props:{
        table:Object
    },
    created(){
        
        console.log(this.table)
    }
}
</script>

<style lang="scss" scoped>
/deep/.cell {
    height: auto;
// overflow: visible;


img{
    height:100px;
}
} 
/deep/ .price >div{
    text-align: left;
}
/deep/.el-form--inline .el-form-item{
    margin-right: 15px;
}
/deep/table{
    overflow-y: scroll;
  tbody  tr{
        height: 200px;
    }
} 
</style>


